import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { GA4Event, GtagConfig, GtagPageview } from './shared/models/gtag.model';
import { UtilityService } from './utility.service';

declare var gtag: any;

@Injectable()
export class GtagService {
  constructor(private router: Router, private utilityService: UtilityService, @Inject('gtagConfig') public gtagConfig: GtagConfig) {
    if (gtagConfig.trackPageViews) {
      router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          tap((event: NavigationEnd) => {
            const pageViewEvent: GA4Event = {
              actionName: 'page_view',
              params: { page_path: event.urlAfterRedirects, domain_url: this.utilityService.getParentBaseUrl() },
            };
            this.logEvent(pageViewEvent);
          })
        )
        .subscribe();
    }
  }

  logEvent(ga4Event: GA4Event) {
    // try/catch to avoid cross-platform issues
    try {
      gtag('event', ga4Event.actionName, ga4Event.params);
      // this.debug('event', this.mergedConfig.trackingId, action, params);
    } catch (err) {
      console.error('Google Analytics event error', err);
    }
  }

  pageview(params?: GtagPageview) {
    try {
      const defaults = {
        page_path: this.router.url,
        page_title: 'Angular App',
        page_location: window.location.href,
      };

      params = { ...defaults, ...params };
      gtag('config', this.gtagConfig.trackingId, params);
    } catch (err) {
      console.error('Google Analytics pageview error', err);
    }
  }

  config(params: any) {
    try {
      gtag('config', this.gtagConfig.trackingId, (params = {}));
    } catch (err) {
      console.error('Google Analytics config error', err);
    }
  }

  set(params: any) {
    try {
      gtag('set', (params = {}));
    } catch (err) {
      console.error('Google Analytics set error', err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/gtag.service.ts